import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  EERegistrationInfo,
  EERegistrationStatus,
  EERegistrationVerificationOptions,
  ValidationRequest,
  ValidationResult
} from '../modules/registration/models/EERegistrationInfo';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  constructor(
    private httpClient: HttpClient,
    @Inject('env') private env: any,
    @Inject('errorInterceptorSkipHeader') private errorInterceptorSkipHeader: any
  ) {}

  public completeRegistration(token: string) {
    const uri = `${this.env.apiUrlRoot}/employee/registration/${token}/completeRegistration`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');
    return this.httpClient.post<{ Uri: string }>(uri, {}, { headers });
  }

  public completeRegistrationVerification(registrationId: string) {
    const uri = `${this.env.apiUrlRoot}/employee/registration/${registrationId}/completeVerification`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');
    return this.httpClient.post<{ Uri: string }>(uri, {}, { headers });
  }

  public getRegistrationDetailsById(registrationId: string): Observable<EERegistrationInfo> {
    const uri = `${this.env.apiUrlRoot}/employee/registration/byId/${registrationId}`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');

    return this.httpClient.get<EERegistrationInfo>(uri, { headers });
  }

  public getRegistrationDetailsByToken(token: string): Observable<EERegistrationInfo> {
    const uri = `${this.env.apiUrlRoot}/employee/registration/byToken/${token}`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');

    return this.httpClient.get<EERegistrationInfo>(uri, { headers });
  }

  public getRecalculatedRegistrationDetailsByToken(token: string): Observable<EERegistrationInfo> {
    const uri = `${this.env.apiUrlRoot}/employee/registration/recalculatedByToken/${token}`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');

    return this.httpClient.get<EERegistrationInfo>(uri, { headers });
  }

  public startRegistration(registrationId: string) {
    const uri = `${this.env.apiUrlRoot}/employee/registration/${registrationId}/start`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');
    return this.httpClient.post<EERegistrationInfo>(uri, {}, { headers });
  }

  public getRegistrationVerificationOptions(
    clientCode: string,
    personId: number
  ): Observable<EERegistrationVerificationOptions> {
    const uri = `${this.env.apiUrlRoot}/Companies/${clientCode}/People/${personId}/GetRegistrationVerificationOptions`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');
    return this.httpClient.get<EERegistrationVerificationOptions>(uri, { headers });
  }

  public getRegistrationByEmployer(
    clientCode: string
  ): Observable<Map<number, EERegistrationStatus>> {
    const uri = `${this.env.apiUrlRoot}/Companies/${clientCode}/GetRegistrationStatusForCompany`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');
    return this.httpClient.get<Map<number, EERegistrationStatus>>(uri, { headers });
  }

  public resetRegistration(clientCode: string, personId: number) {
    const uri = `${this.env.apiUrlRoot}/Companies/${clientCode}/ResetRegistration/${personId}`;
    return this.httpClient.post<EERegistrationInfo>(uri, {});
  }

  public verifyRegistrationQuestion(
    clientCode: string,
    personId: number,
    request: ValidationRequest
  ): Observable<ValidationResult> {
    const uri = `${this.env.apiUrlRoot}/Companies/${clientCode}/People/${personId}/VerifyRegistrationQuestion`;
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');

    return this.httpClient.post<ValidationResult>(uri, request, { headers });
  }
}
